import React from 'react';
import APIUsages from '@/containers/APIUsage';
import { Route, Switch } from 'react-router-dom';
import CropRequests from '@/containers/CropRequest';
import PrintRequests from '@/containers/PrintRequest';
import CropRequestPrices from '@/containers/CropRequestPrice';
import SubscriptionPrices from '@/containers/SubscriptionPrice';

export default () => (
  <Switch>
    <Route path="/marketplace/croprequests" component={CropRequests} />
    <Route path="/marketplace/printrequests" component={PrintRequests} />
    <Route path="/marketplace/apiusage" component={APIUsages} />
    <Route path="/marketplace/export_pricing" component={CropRequestPrices} />
    <Route path="/marketplace/subscription_pricing" component={SubscriptionPrices} />
  </Switch>
);
